'use strict';

Object.defineProperty(exports, "__esModule", {
            value: true
});
/*
    The config parameters are also used to get data from live-presence.json
    A config with a dash maps to same parameter without dash in json file
    ie particulier-geenwelkom => particulier
*/

exports.default = {
            SCRIPT: 'https://www.centraalbeheer.nl/Style%20Library/cb_style_2014/script/js/vendor/livepresence.compat.js',
            RESOURCE: '/json/live-presence-url-config.json.js',
            CONFIG: {
                        'homepage': {
                                    kInitialLanguage: 'nl-nl',
                                    kInitialAgentMessage: '',

                                    kErrorTimestampPrefix: 'Weergegeven om ',
                                    kErrorMessagePrefix: 'De verbinding met de server ondervindt momenteel moeilijkheden. Excuses voor het ongemak.',

                                    kUserName: '',
                                    kUserTimestampPrefix: 'Verzonden om ',
                                    kUserMessagePrefix: '',

                                    kAgentName: 'Centraal Beheer',
                                    kAgentTimestampPrefix: 'Ontvangen om ',
                                    kAgentMessagePrefix: ''
                        },
                        'particulier': {
                                    kInitialLanguage: 'nl-nl',
                                    kInitialAgentMessage: '',

                                    kErrorTimestampPrefix: 'Weergegeven om ',
                                    kErrorMessagePrefix: 'De verbinding met de server ondervindt momenteel moeilijkheden. Excuses voor het ongemak.',

                                    kUserName: '',
                                    kUserTimestampPrefix: 'Verzonden om ',
                                    kUserMessagePrefix: '',

                                    kAgentName: '',
                                    kAgentTimestampPrefix: 'Ontvangen om ',
                                    kAgentMessagePrefix: ''
                        },
                        'particulier-geenwelkom': { //Empty initial message, in case Live Presence generates this server side (ie email)
                                    kInitialLanguage: 'nl-nl',
                                    kInitialAgentMessage: '',

                                    kErrorTimestampPrefix: 'Weergegeven om ',
                                    kErrorMessagePrefix: 'De verbinding met de server ondervindt momenteel moeilijkheden. Excuses voor het ongemak.',

                                    kUserName: '',
                                    kUserTimestampPrefix: 'Verzonden om ',
                                    kUserMessagePrefix: ' zegt: ',

                                    kAgentName: 'Centraal Beheer',
                                    kAgentTimestampPrefix: 'Ontvangen om ',
                                    kAgentMessagePrefix: ' zegt: '
                        },
                        'zakelijk': {
                                    kInitialLanguage: 'nl-nl',
                                    kInitialAgentMessage: 'Welkom bij Centraal Beheer. Waarmee kan ik u van dienst zijn?',

                                    kErrorTimestampPrefix: 'Weergegeven om ',
                                    kErrorMessagePrefix: 'De verbinding met de server ondervindt momenteel moeilijkheden. Excuses voor het ongemak.',

                                    kUserName: '',
                                    kUserTimestampPrefix: 'Verzonden om ',
                                    kUserMessagePrefix: ' zegt: ',

                                    kAgentName: 'Centraal Beheer',
                                    kAgentTimestampPrefix: 'Ontvangen om ',
                                    kAgentMessagePrefix: ' zegt: '
                        }
            },
            INPUT_SELECTOR: '#iChatInputField',
            BUTTON_SELECTOR: '#verstuur-livepresence-inlogpagina'
};


//////////////////
// WEBPACK FOOTER
// ./src/lib/ui-components/chat/live-presence-sharepoint.constants.js
// module id = 873
// module chunks = 0